<template lang="pug">
#graficoPluviosidade
    apex-charts.component.apexcharts-canvas(
        type='line',
        height='300',
        :options='options',
        :series='series'
    )
</template>

<script>
import { GRAFICO_PLUVIOSIDADE_ACUMULADA } from '@/utils/layouts/graficos';
import ApexCharts from 'vue-apexcharts';

const JANEIRO = 1;
const DEZEMBRO = 12;

export default {
    name: 'GraficoPluviosidade',
    components: {
        ApexCharts
    },
    data() {
        return {
            series: [],
            options: GRAFICO_PLUVIOSIDADE_ACUMULADA
        };
    },

    props: {
        historico: {
            type: Array,
            required: true
        }
    },

    methods: {
        configureDados() {
            let anos = _.uniq(
                _.map(this.historico, historico => historico.ano)
            );

            _.each(anos, ano => {
                let dadosAno = _.filter(
                    this.historico,
                    historico => historico.ano === ano
                );

                this.buildSeries(dadosAno, ano);
            });

            this.buildMediaMensal();
        },

        buildSeries(dadosAno, ano) {
            this.series.push({
                name: ano.toString(),
                type: 'column',
                data: _.map(dadosAno, dado => dado.valor)
            });
        },

        buildMediaMensal() {
            let mediasMensais = [];

            for (let i = JANEIRO; i <= DEZEMBRO; i++) {
                let dadosMes = _.filter(this.historico, h => {
                    return h.mes === i;
                });

                let mediaMensal = _.meanBy(dadosMes, dado => dado.valor);

                mediasMensais.push(mediaMensal);
            }

            this.series.push({
                name: 'Média histórica',
                type: 'line',
                data: mediasMensais
            });
        }
    },

    mounted() {
        this.configureDados();
    }
};
</script>

<style scoped></style>
